function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3225 3.69465L13.191 1.0045L15.1694 3.85284L15.541 4.38795L15.9127 3.85284L17.5484 1.49783V11.5819H9.01637V1.44474L10.5792 3.69466L10.9508 4.22976L11.3225 3.69465Z",
  fill: "#FFD9B0",
  stroke: "#055445",
  strokeWidth: 0.905061
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7964 11.1294H4.76829C2.13484 11.1294 0 13.2642 0 15.8977V37.4866C0 40.1201 2.13484 42.2549 4.76829 42.2549H21.7964C24.4299 42.2549 26.5647 40.1201 26.5647 37.4866V15.8977C26.5647 13.2642 24.4299 11.1294 21.7964 11.1294Z",
  fill: "#055445"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2781 16.2244H7.21215C6.61578 16.2244 6.13232 16.7078 6.13232 17.3042V23.4715C6.13232 24.0679 6.61578 24.5513 7.21215 24.5513H20.2781C20.8744 24.5513 21.3579 24.0679 21.3579 23.4715V17.3042C21.3579 16.7078 20.8744 16.2244 20.2781 16.2244Z",
  fill: "white",
  stroke: "#055445",
  strokeWidth: 1.04194,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.95837 28.6482H9.91937",
  stroke: "#FFD9B0",
  strokeWidth: 1.35926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2446 28.6482H15.2056",
  stroke: "#FFD9B0",
  strokeWidth: 1.35926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5718 28.6482H20.5318",
  stroke: "#FFD9B0",
  strokeWidth: 1.35926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.95837 31.503H9.91937",
  stroke: "#FFD9B0",
  strokeWidth: 1.35926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2446 31.503H15.2056",
  stroke: "#FFD9B0",
  strokeWidth: 1.35926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5718 31.503H20.5318",
  stroke: "#FFD9B0",
  strokeWidth: 1.35926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M6.95837 34.3578H9.91937",
  stroke: "#FFD9B0",
  strokeWidth: 1.35926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2446 34.3578H20.5318",
  stroke: "#FFD9B0",
  strokeWidth: 1.35926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1775 20.3125L13.6656 21.4577L16.2297 18.8936",
  stroke: "#055445",
  strokeWidth: 1.04194,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9734 21.9902H37.1186C37.3022 21.9902 37.4783 22.0631 37.6082 22.193C37.738 22.3228 37.811 22.4989 37.811 22.6826V44.7092C37.811 45.8472 37.3589 46.9386 36.5542 47.7433C35.7495 48.548 34.6581 49.0001 33.5201 49.0001H17.9734C17.7898 49.0001 17.6137 48.9271 17.4838 48.7973C17.354 48.6674 17.281 48.4913 17.281 48.3076V22.6807C17.2815 22.4974 17.3547 22.3218 17.4845 22.1923C17.6143 22.0629 17.7901 21.9902 17.9734 21.9902Z",
  fill: "#E4FFE1",
  stroke: "#055445",
  strokeWidth: 1.669,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2126 49.0001C34.2126 49.0001 30.2409 48.8855 30.6425 43.4948H12.1775V45.1544C12.1774 45.6594 12.2768 46.1596 12.47 46.6262C12.6632 47.0928 12.9465 47.5168 13.3036 47.874C13.6607 48.2311 14.0847 48.5144 14.5514 48.7076C15.018 48.9008 15.5181 49.0002 16.0232 49.0001H34.2098",
  fill: "#E4FFE1"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2126 49.0001C34.2126 49.0001 30.2409 48.8855 30.6425 43.4948H12.1775V45.1544C12.1774 45.6594 12.2768 46.1596 12.47 46.6262C12.6632 47.0928 12.9465 47.5168 13.3036 47.874C13.6607 48.2311 14.0847 48.5144 14.5514 48.7076C15.018 48.9008 15.5181 49.0002 16.0232 49.0001H34.2098",
  stroke: "#055445",
  strokeWidth: 1.669,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1075 25.8075H34.9845",
  stroke: "#055445",
  strokeWidth: 0.827867,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1075 28.9058H34.9845",
  stroke: "#055445",
  strokeWidth: 0.827867,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1075 32.0042H34.9845",
  stroke: "#055445",
  strokeWidth: 0.827867,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1075 35.1025H34.9845",
  stroke: "#055445",
  strokeWidth: 0.827867,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1075 38.1999H34.9845",
  stroke: "#055445",
  strokeWidth: 0.827867,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgPayBills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 50,
    viewBox: "0 0 39 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayBills);
export default __webpack_public_path__ + "static/media/payBills.ab8c7c4f372d1c0e685ca0b26abdf3fc.svg";
export { ForwardRef as ReactComponent };